import SingleLayout from 'Layout/infoLayout'
import SingleBody from 'components/SingleBody';

const LocationInfo = ({ data, isLoading }) => {
    return (
        data?.map((item, index) => (
            <SingleLayout key={index} image={item.image} paralaxBg={item.paralax_type} type={item.type} isLoading={isLoading}>
                <SingleBody label={item.tag} title={item.title} desc={item.description} button={item.button_text} link={item.button_link} />
            </SingleLayout>
        ))
    )

}


export default LocationInfo;